import {
  Box,
  Typography,
} from '@mui/material';
import { Card } from '@liminal/web-ui/primitives/Card';
import { Banner } from '@liminal/web-ui/brand/generated/Banner';
import { styled } from '@mui/material/styles';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './context';
import { LoadingSpinner } from '@liminal/web-ui/feedback/LoadingSpinner';
import { FormErrorBanner } from '@liminal/web-ui/forms/FormErrorBanner';

const PageRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(0, 2),
}));

const LogoArea = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(4),
}));

export function LoginPage() {
  const { isAuthenticated, isLoading, error, handleGoogleSuccess, handleGoogleError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  return (
    <PageRoot>
      <Card variant="elevated" padding="none" sx={{ maxWidth: 400, width: '100%' }}>
        <Box sx={{ p: 4 }}>
          <LogoArea>
            <Banner size={40} title="Liminal" />
            <Typography variant="body2" color="text.secondary">
              Admin
            </Typography>
          </LogoArea>

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Sign in with your @liminal.cash Google account
            </Typography>

            <FormErrorBanner error={error || undefined} />

            {isLoading ? (
              <LoadingSpinner variant="inline" />
            ) : (
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                hosted_domain="liminal.cash"
                theme="outline"
                size="large"
                width="320"
              />
            )}
          </Box>
        </Box>
      </Card>
    </PageRoot>
  );
}
